const SELECT_CONTENT_GROUP_ATTR = 'data-select-content';
const SELECT_CONTENT_TRIGGER_ATTR = 'data-select-content-trigger';
const SELECT_CONTENT_LISTENER_ATTR = 'data-select-content-listener';
const SELECT_CONTENT_TRIGGER_LOADED_ATTR = 'data-select-content-loaded';
const SELECT_CONTENT_ACTIVE_CLASS_ATTR = 'data-select-content-active';

const ARIA_HIDDEN_ATTR = 'aria-hidden';

const SELECT_CONTENT_GROUP_SELECTOR = '[' + SELECT_CONTENT_GROUP_ATTR + ']';
const SELECT_CONTENT_LISTENER_SELECTOR = '[' + SELECT_CONTENT_LISTENER_ATTR + ']';
const SELECT_CONTENT_TRIGGER_SELECTOR = '[' + SELECT_CONTENT_TRIGGER_ATTR + '][' + SELECT_CONTENT_TRIGGER_LOADED_ATTR + ']';
const SELECT_CONTENT_NEW_TRIGGER_SELECTOR = '[' + SELECT_CONTENT_TRIGGER_ATTR + ']:not([' + SELECT_CONTENT_TRIGGER_LOADED_ATTR + '])';

/**
 * Generic solution that toggles active classes on specific elements depending on the state of a select dropdown.
 * The elements are grouped. 
 */

/*

<select
    data-select-content="skadeanmalan" // Group id
    data-select-content-trigger         // Trigger marker
>
    <option value="test-1">Test 1</option>
    <option value="test-2">Test 2</option>
    <option value="test-3">Test 3</option>
    <option value="test-4">Test 4</option>
</select>
[....]
<div 
    class="content"
    data-select-content="skadeanmalan"             // Group id
    data-select-content-active="content--active"   // Active class to check for / use
    data-select-content-listener                   // Listener marker
>
    [..]
</div>
*/

function addClass(element, className){
    return element.classList.add(className);
}

function removeClass(element, className){
    return element.classList.remove(className);
}

export default class SelectContentHandler {
    constructor() {
        this.eventListeners = [];
        this.setupEventListeners();
    }

    setupEventListeners() {
        const triggers = [...document.querySelectorAll(SELECT_CONTENT_NEW_TRIGGER_SELECTOR)];
console.log(triggers);
        triggers.map((element) => {
            element.setAttribute(SELECT_CONTENT_TRIGGER_LOADED_ATTR, true);
            element.addEventListener('change', (ev) => { this.onSelectChange(ev.target); });
            this.onSelectChange(element);
        });
    }

    onSelectChange(selectElement) {
        const selectGroup = selectElement.getAttribute(SELECT_CONTENT_GROUP_ATTR);
        const selectedOption = selectElement.value;

        const selectContentsSelector = '[' +SELECT_CONTENT_GROUP_ATTR+ '="' + selectGroup + '"]';
        const newActiveContentSelector = '[' + SELECT_CONTENT_GROUP_ATTR + '="' + selectGroup + '"][' + SELECT_CONTENT_LISTENER_ATTR + '="' + selectedOption + '"]';

        const allContents = [...document.querySelectorAll(selectContentsSelector)];
        const newActiveContents = [...document.querySelectorAll(newActiveContentSelector)];

        allContents.forEach((content) => {
            const activeClass = content.getAttribute(SELECT_CONTENT_ACTIVE_CLASS_ATTR);
            content.setAttribute(ARIA_HIDDEN_ATTR, true);
            removeClass(content, activeClass);
        });

        newActiveContents.forEach((content) => {
            const activeClass = content.getAttribute(SELECT_CONTENT_ACTIVE_CLASS_ATTR)
            content.setAttribute(ARIA_HIDDEN_ATTR, false);
            addClass(content, activeClass);
        });
    }
}